import { FormApi, axios } from './config'
import { getShareQrcode, proxyApi } from './common'
import { UAID } from '@/configs/constants'
import wechat from '@/store/index'
import { Dialog } from 'vant'
function memberApi(target, data) {
    return proxyApi('membership', ...arguments)
}

/**
 * 礼享积分同步
 *
 * @export
 */
export async function getEgRedirect(){
    return  memberApi('Enjoygifts:SyncPoints')
}

/**
 * 礼享会员收货信息同步
 *
 * @export
 * @return {*} 
 */
export async function syncAddress(){
    return  memberApi('Enjoygifts:SyncAddress')
}

// 是否是会员
export const checkMember = async (needSubscribe=false) => {
    if (needSubscribe && wechat.state.userInfo?.subscribe !== 1) {
        console.log(wechat.state.userInfo?.subscribe)
        const base64Img = await getShareQrcode()
        return Dialog({
            message: `<img width='100%' src='${base64Img}'><span>长按二维码前往注册</span>`,
            showConfirmButton: false,
            allowHtml: true,
            closeOnClickOverlay: true
        })
    }
    return await memberApi('CheckMember')
}
//会员信息
export const getMemberInfo = async (include = false) => {
    return await memberApi('GetMember', {
        include
    })
}
//更新会员信息
export const updateMember = async input => {
    return await memberApi('UpdateMember', {
        input,
        isPartialUpdate: true
    })
}

// 礼品列表
export const getProducts = async (index = 1, size = 20) => {
    return await memberApi('GetProducts', {
        index,
        size
    })
}
// 礼品列表
export const getProduct = async productId => {
    return await memberApi('GetProduct', {
        productId
    })
}

// 兑换
export const placeOrder = async input => {
    return await memberApi('PlaceOrder', {
        input
    })
}
// 获取积分记录
export const getPointRecords = async ({
    index = 1,
    size = 999,
    desc = true,
    from,
    to,
    SourceDescriptions,
    sourceType
} = {}) => {
    return await memberApi('GetPointRecords', {
        index,
        size,
        desc,
        from,
        to,
        sourceType,
        SourceDescriptions
    })
}
//获取订单记录
export const getOrders = async ({
    index = 1,
    size = 20,
    desc = true,
    isShipped
} = {}) => {
    return await memberApi('GetOrders', {
        index,
        size,
        desc,
        isShipped
    })
}
// 获取收藏
export const getBookmarks = async (index = 1, size = 'all', desc = true) => {
    return await memberApi('GetBookmarks', {
        index,
        size: size === 'all' ? 999 : size,
        desc
    })
}

// 添加收藏
export /**
 *
 * @param {*} input
 * @returns
 */
const addBookmark = async ({ name, url, detail }) => {
    return await memberApi('AddBookmark', {
        input: { name, url, uaId: UAID, detail }
    })
}
// 取消收藏
export const deleteBookmark = async bookmarkId => {
    return await memberApi('DeleteBookmark', {
        bookmarkId
    })
}
// 获取收件人
export const getRecipients = async (index = 1, size = 999, desc = true) => {
    return await memberApi('GetRecipients', {
        index,
        size,
        desc
    })
}
// 删除收件人
export const deleteRecipient = async recipientId => {
    return await memberApi('DeleteRecipient', {
        recipientId
    })
}
// 收件人详情
export const getRecipient = async recipientId => {
    return await memberApi('GetRecipient', {
        recipientId
    })
}
// 更改/新增收件人
export const updateRecipient = async (input, recipientId) => {
    if (recipientId) {
        return await memberApi('UpdateRecipient', {
            recipientId,
            input
        })
    } else {
        return await memberApi('AddRecipient', {
            input
        })
    }
}
// 积分商城设置
export const getPointStoreSetting = async () => {
    return await memberApi('GetPointStoreSetting')
}
// 地址
export const getAddress = async () => {
    return await axios.get(FormApi + '/preset/address.json')
}
// 成为会员表单设置
export const getMembershipLevelSettings = async () => {
    return await memberApi('GetMembershipLevelSettings')
}
